import { render, staticRenderFns } from "./ProjectEditLayoutBudgetsTab.vue?vue&type=template&id=64c8b11e"
import script from "./ProjectEditLayoutBudgetsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditLayoutBudgetsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports